"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetPopularData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _tsUtils = require("@ori/ts-utils");
var _esToolkit = require("es-toolkit");
var _react = require("react");
var _constants = require("../constants");
var _popularData = require("../queries-net/popularData");
var _utils = require("../utils");
// istanbul ignore file @preserve -- api

const useGetPopularData = ({
  numberOfProducts,
  enabled
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    data: bestsellerData,
    isLoading: isLoadingBestsellers
  } = (0, _staticApiClientReact.useGetTenantBestsellers)(tenant, {
    lang: language,
    take: numberOfProducts
  }, {
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled
    }
  });
  const bestsellerProductCodes = (0, _react.useMemo)(() => (0, _esToolkit.uniq)((0, _esToolkit.compact)((bestsellerData?.result ?? []).map(item => item.conceptCode ?? ''))), [bestsellerData?.result]);
  const {
    data: products,
    isLoading
  } = (0, _fetching.useGraphqlQuery)({
    url: graphQlNetUrl,
    query: _popularData.popularDataQuery,
    headers,
    variables: {
      productCodes: bestsellerProductCodes
    },
    skip: loadingHeaders || bestsellerProductCodes.length === 0 || isLoadingBestsellers,
    swrConfig: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  const popularProducts = (0, _react.useMemo)(() => products?.products?.filter(_tsUtils.isNonNullable).map(mappedProduct => (0, _utils.mapSearchPreviewProduct)({
    product: mappedProduct,
    personalSubscriptionsEnabled: isFeatureEnabled(_constants.TopAreaFeature.PersonalSubscriptions)
  })) ?? [], [products, isFeatureEnabled]);

  // TODO
  const popularSearchQueries = (0, _react.useMemo)(() => [], []);
  return {
    data: {
      popularProducts,
      popularSearchQueries
    },
    isLoading: isLoading || isLoadingBestsellers || loadingHeaders
  };
};
exports.useGetPopularData = useGetPopularData;
